import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import type { NavigationDialogState } from '@/hooks/mastra/use-streaming-completion';

interface AINavigationConfirmDialogProps {
  navigationDialog: NavigationDialogState;
}

export function AINavigationConfirmDialog({ navigationDialog }: AINavigationConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={navigationDialog.isOpen}
      onOpenChange={(open) => {
        if (!open) {
          navigationDialog.onCancel();
        }
      }}
      title="AI generation in progress"
      description="You have an AI generation in progress. If you leave now, you'll lose the generated content. Are you sure you want to leave?"
      confirmLabel="Leave page"
      cancelLabel="Stay on page"
      onConfirm={navigationDialog.onConfirm}
      onCancel={navigationDialog.onCancel}
      confirmColorScheme="destructive"
    />
  );
}
